module.exports = __webpack_public_path__ + "img/jobmule_cv_ricevuti.5f1fd727.png";